import { useDataSourceStore } from '@/stores/dataSource';

// Options API pages read the same store; no local copies or browser events.
export const dataSourceMixin = {
  computed: {
    dataSource() { return useDataSourceStore().mode; },
    isMockData() { return useDataSourceStore().isMock; },
  },
  methods: {
    captureDataSource() {
      const store = useDataSourceStore();
      const revision = store.revision;
      return () => store.revision === revision;
    },
  },
  watch: {
    dataSource(source) { return this.onDataSourceChanged?.(source); },
  },
};
